import React, { Component, Fragment } from 'react';
import Navigation from '../components/Navigation';
import { translate } from 'react-i18next';
import axios from 'axios';
import {
    Panel,
    Col,
    Row,
    Button,
    FormControl,
    Form,
    FormGroup
} from 'react-bootstrap';
import PaginationPanel from '../components/PaginationPanel';
import config from '../config';
import qs from 'qs';
import MediaLibraryRulesTable from '../components/MediaLibraryRulesTable';
import { Link } from 'react-router-dom';
import Dialog from 'react-bootstrap-dialog';
import ReactPaginate from 'react-paginate';
import TooltipButton from '../components/TooltipButton';

import './MediaLibraryRules.css';

class MediaLibraryRules extends Component {
    constructor(props) {
        super(props);
        const { uuid } = this.props.match.params;

        this.state = {
            user: props.user,
            userIsAuthorized: props.userIsAuthorized,
            medialibrary: { name: '' },
            rulegroups: null,
            page: props.page,
            limit: 1000,
            pageCount: 0,
            selected: props.selected - 1
        };
    }

    deleteRule(rulegroup, rule) {
        var self = this;
        axios
            .delete(
                `${config.baseURL}/medialibraries/${this.state.medialibrary.uuid}/rulegroups/${
                    rulegroup.uuid
                }/rules/${rule.uuid}`
            )
            .then(function(result) {
                self.loadMediaLibraryRuleGroupsFromServer();
            })
            .catch(function(err) {
                console.log(`Error deleting rule: ${rule} error: ${err}`);
            });
    }

    editRule(rulegroup, rule) {
        const {
            uuid,
            mediaLibraryUUID
        } = this.props.match.params;

        const parsed = qs.parse(this.props.location.search.substring(1));
        const rel = parsed.rel;

        let link = `/organisations/${uuid}/medialibraries/${mediaLibraryUUID}/rulegroups/${rulegroup.uuid}/rules/${
            rule.uuid
        }/edit?rel=library`;

        this.props.history.push(link);
    }

    componentDidMount() {
        this.loadMediaLibraryFromServer();
        this.loadMediaLibraryRuleGroupsFromServer();
    }

    loadMediaLibraryFromServer() {
        const { mediaLibraryUUID } = this.props.match.params;

        let self = this;
        axios
            .get(`${config.baseURL}/medialibraries/${mediaLibraryUUID}`, {})
            .then(function(response) {
                self.setState({ medialibrary: response.data.medialibrary });
                self.loadOrganisationInformation();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadOrganisationInformation() {
        var self = this;

        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}`, {})
            .then(function(response) {
                self.setState({
                    organisation_name: response.data.organisation.name
                });

                const parsed = qs.parse(
                    self.props.location.search.substring(1)
                );
                const rel = parsed.rel;
                if (rel === 'player') {
                    self.loadPlayerFromServer();
                }
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadPlayerFromServer() {
        var self = this;
        const { playerUUID } = this.props.match.params;

        axios
            .get(`${config.baseURL}/players/${playerUUID}`, {})
            .then(function(response) {
                self.setState({
                    player_name: response.data.player.name
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadMediaLibraryRuleGroupsFromServer() {
        const { mediaLibraryUUID } = this.props.match.params;

        let self = this;
        axios
            .get(`${config.baseURL}/medialibraries/${mediaLibraryUUID}/rulegroups`, {})
            .then(function(response) {
                if (
                    response.data.rulegroups &&
                    response.data.rulegroups.length > 0
                ) {
                    self.setState(
                        { rulegroups: response.data.rulegroups },
                        () => {
                            self.loadRuleGroupRulesFromServer();
                        }
                    );
                }
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    handleChange = (event, rulegroup) => {
        const { mediaLibraryUUID } = this.props.match.params;

        const newOperator = event.target.value;

        let self = this;

        axios
            .patch(
                `${config.baseURL}/medialibraries/${mediaLibraryUUID}/rulegroups/${
                    rulegroup.uuid
                }`,
                {
                    name: rulegroup.name,
                    operator: newOperator
                }
            )
            .then(function(response) {
                self.loadMediaLibraryRuleGroupsFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    };

    handleAddRuleGroup() {

        const { mediaLibraryUUID } = this.props.match.params;

        const ruleGroupProperties = {
            name: 'Rule Group',
            operator: 'AND'
        }

         let self = this;
            axios
                .post(
                    `${config.baseURL}/medialibraries/${
                        mediaLibraryUUID
                    }/rulegroups`,
                    ruleGroupProperties
                )
                .then(function(response) {
                    self.loadMediaLibraryRuleGroupsFromServer();
                })
    }

    loadRuleGroupRulesFromServer() {
        const { mediaLibraryUUID } = this.props.match.params;

        let self = this;

        let rulegroups = this.state.rulegroups;

        function getAllRules(rgs){
            return Promise.all(rgs.map(fetchRules));
        }
          
        function fetchRules(rulegroup) {
            return axios
              .get(`${config.baseURL}/medialibraries/${mediaLibraryUUID}/rulegroups/${rulegroup.uuid}/rules`,
                {
                    params: {
                        page: self.state.page,
                        limit: self.state.limit
                    }
                })
              .then(function(response) {
                
                rulegroup.rules = response.data.rules;

                return {
                    success: true,
                    rules: response.data.rules
                };

              })
              .catch(function(error) {
                return { success: false };
              });
        }

        getAllRules(rulegroups).then((resp) => {

            console.log(`Resp: ${JSON.stringify(resp)}`);
            
            self.setState({
                rulegroups
            });

        }).catch((e)=>{console.log(e)})
    }

    handlePageClick = data => {

        let selected = data.selected + 1;

        const url = new URL(window.location.href);
        url.searchParams.set('page', selected);
        window.history.pushState(null, null, url); 

        this.setState({ page: selected, selected: data.selected }, () => {
            this.loadRuleGroupRulesFromServer();
        });
    };

    handleDeleteRuleGroupClicked(rulegroup) {
        var self = this;
        axios.delete(`${config.baseURL}/medialibraries/${this.state.medialibrary.uuid}/rulegroups/${rulegroup.uuid}/`)
            .then(function(result) {
                self.loadMediaLibraryRuleGroupsFromServer();
            })
            .catch(function(err) {
                console.log(`Error deleting rulegroup: ${JSON.stringify(rulegroup)} error: ${err}`);
            });
    }

    render() {
        const { t } = this.props;
        const {
            uuid,
            mediaLibraryUUID,
            playerUUID,
            pageUUID,
            snippetUUID,
            mediaUUID
        } = this.props.match.params;

        const parsed = qs.parse(this.props.location.search.substring(1));
        const rel = parsed.rel;
        document.title = `MySign Digital Screen Solutions | ${t(
            'MediaLibraryRules.title'
        )}`;

        let ruleGroupPanels = null;
        if (this.state.rulegroups && this.state.rulegroups.length > 0) {

            ruleGroupPanels = this.state.rulegroups.map((rulegroup, i) => {

                const {
                    uuid,
                    mediaLibraryUUID,
                    mediaUUID
                } = this.props.match.params;
        
                const parsed = qs.parse(this.props.location.search.substring(1));
                const rel = parsed.rel;
        
                let createRuleLink = `/organisations/${uuid}/medialibraries/${mediaLibraryUUID}/rulegroups/${rulegroup.uuid}/rules/create?rel=library`;
    
                return (
                    <>
                    <PaginationPanel
                                heading={
                                    <Form inline>
                                        <FormGroup>
                                            <h4
                                                style={{
                                                    display: 'inline'
                                                }}
                                            >
                                                {t('MediaLibraryRules.show_if')}
                                            </h4>{' '}
                                            <FormControl
                                                className="select input-sm"
                                                componentClass="select"
                                                placeholder="Choose..."
                                                value={
                                                    rulegroup
                                                        .operator
                                                }
                                                onChange={(e) => this.handleChange(e, rulegroup)}
                                            >
                                                <option value="AND">
                                                    {t('MediaLibraryRules.all')}
                                                </option>
                                                <option value="OR">
                                                    {t('MediaLibraryRules.any')}
                                                </option>
                                            </FormControl>{' '}
                                            <h4
                                                style={{
                                                    display: 'inline'
                                                }}
                                            >
                                                {t(
                                                    'MediaLibraryRules.of_the_rules_below_apply'
                                                )}
                                            </h4>
                    
                                        </FormGroup>
                                        {this.state.userIsAuthorized(
                                                this.state.user,
                                                [
                                                    'staff_super_admin',
                                                    'staff_admin',
                                                    'organisation_admin',
                                                    'organisation_user'
                                                ]
                                            ) ? (
                                            <div className="buttonContainer">
                                                <Link
                                                    type="submit"
                                                    className="btn btn-primary text-right addRule"
                                                    to={createRuleLink}
                                                
                                                >
                                                    <em className="fa fa-plus fa-fw" />{' '}
                                                    {t('MediaLibraryRules.add_rule')}
                                                </Link> {' '}
                                                <TooltipButton
                                    tooltip={t(
                                        'MediaLibraryRules.deleterulegroup'
                                    )}
                                    className="btn-danger "
                                    onClick={() =>
                                        this.handleDeleteRuleGroupClicked(rulegroup)
                                    }
                                >
                                    <em className="fa fa-trash" />
                                </TooltipButton>
                                            </div>
                                            ) : null}
                                    </Form>
                                    
                                }
                                pagination={
                                    (null)
                                }
                            >
                                        {/* console.log(`MediaLibraryRulesTable: ${JSON.stringify(rulegroup)}`); */}
                                        <MediaLibraryRulesTable
                                            userIsAuthorized={
                                                this.state.userIsAuthorized
                                            }
                                            user={this.state.user}
                                            rulegroup={rulegroup}
                                            rules={rulegroup.rules}
                                            mediaLibraryUUID={mediaUUID}
                                            onDelete={this.deleteRule.bind(this)}
                                            handleEditClicked={this.editRule.bind(
                                                this
                                            )}
                                            
                                        />
                                    </PaginationPanel>
                                    { i < this.state.rulegroups.length - 1 ? (

                                             <span className="label label-primary logicSeperator">
                                               <em className="fa fa-plus fa-fw logicSeperator" /> AND
                                            </span>

                                    ) : (null)}
                                    
                                    </>
                                   
                );
        }
        
            )};

        return (
            <div className="MediaLibraryRules">
                <Dialog
                    ref={el => {
                        this.dialog = el;
                    }}
                />
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('MediaLibraryRules.title')}
                                    {' - '}
                                    {this.state.medialibrary.name}{' '}
                                    {rel === 'player' ? (
                                        <small>
                                            {this.state.player_name}{' '}
                                            <small
                                                style={{
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {this.state.organisation_name}
                                            </small>
                                        </small>
                                    ) : (
                                        <small>
                                            {this.state.organisation_name}
                                        </small>
                                    )}
                                    {this.state.userIsAuthorized(
                                        this.state.user,
                                        [
                                            'staff_super_admin',
                                            'staff_admin',
                                            'organisation_admin',
                                            'organisation_user'
                                        ]
                                    ) ? (
                                        <TooltipButton
                                            id=""
                                            className="btn btn-success"
                                            tooltip={t('MediaLibraryRules.add_rule_group')}
                                            onClick={() =>
                                                this.handleAddRuleGroup()
                                            }
                                        >
                                            <em className="fa fa-plus fa-fw" />{t('MediaLibraryRules.add_rule_group')}
                                        </TooltipButton>
                                    ) : null}
                                    {rel === 'player' ? (
                                        <>
                                        <a
                                            id="previewButton"
                                            type="submit"
                                            className="btn btn-success header-button"
                                            target="_blank"
                                            href={`${
                                                config.playersBaseURL
                                            }/mediaserver/unit.php?playerUUID=${playerUUID}&preview=1`}
                                        >
                                            <em className="fa fa-eye fa-fw" />{' '}
                                            {t('Player.preview_player')}
                                        </a>

                                        <a
                                            id="previewButton"
                                            type="submit"
                                            className="btn btn-warning header-button"
                                            target="_blank"
                                            href={`${
                                                config.playersBaseURL
                                            }/mediaserver/unit.php?playerUUID=${playerUUID}&preview=1&ignoreRules=1`}
                                        >
                                            <em className="fa fa-eye fa-fw" />{' '}
                                            {t('Player.preview_player_all')}
                                        </a>

                                        </>
                                    ) : null}
                                </h1>

                                <ol className="breadcrumb">
                                    {rel === 'player' ? (
                                        <Fragment>
                                            {' '}
                                            <li>
                                                <i className="fa fa-tachometer-alt" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}`}
                                                >
                                                    {t('Dashboard.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-tv" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players`}
                                                >
                                                    {t(
                                                        'SideNavigation.players'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-tv" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}`}
                                                >
                                                    {t(
                                                        'OrganisationPlayer.title'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-file" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}/pages/`}
                                                >
                                                    {t('SideNavigation.pages')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-puzzle-piece" />
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}/pages/${pageUUID}?rel=player`}
                                                >
                                                    {' '}
                                                    {t('Page.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-images" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}/pages/${pageUUID}/mediasnippets/${snippetUUID}?rel=player`}
                                                >
                                                    {t('MediaLibrarySnippet.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-images" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}/pages/${pageUUID}/mediasnippets/${snippetUUID}/medialibraries/${mediaLibraryUUID}?rel=player`}
                                                >
                                                    {t(
                                                        'MediaSnippetMediaLibrary.title'
                                                    )}
                                                </Link>
                                            </li>
                                            <li className="active">
                                                <i className="fas fa-clipboard-list" />{' '}
                                                {t('MediaLibraryRules.title')}
                                            </li>{' '}
                                        </Fragment>
                                    ) : null}

                                    {rel === 'library' ? (
                                        <Fragment>
                                            {' '}
                                            <li>
                                                <i className="fa fa-tachometer-alt" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}`}
                                                >
                                                    {t('Dashboard.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-images" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/medialibraries?rel=library`}
                                                >
                                                    {t(
                                                        'SideNavigation.globalmedialibraries'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-images" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/medialibraries/${mediaLibraryUUID}?rel=library`}
                                                >
                                                    {t(
                                                        'MediaSnippetMediaLibrary.title'
                                                    )}
                                                </Link>
                                            </li>
                                            <li className="active">
                                                <i className="fas fa-clipboard-list" />{' '}
                                                {t('MediaLibraryRules.title')}
                                            </li>{' '}
                                        </Fragment>
                                    ) : null}

                                    {rel === 'snippet' ? (
                                        <React.Fragment>
                                            <li>
                                                <i className="fa fa-tachometer-alt" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}`}
                                                >
                                                    {t('Dashboard.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-puzzle-piece" />
                                                <Link
                                                    to={`/organisations/${uuid}/snippets`}
                                                >
                                                    {' '}
                                                    {t(
                                                        'SideNavigation.globalsnippets'
                                                    )}
                                                </Link>
                                            </li>{' '}
                                            <li>
                                                <i className="fas fa-images" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/mediasnippets/${snippetUUID}?rel=snippet`}
                                                >
                                                    {t('MediaLibrarySnippet.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-images" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/mediasnippets/${snippetUUID}/medialibraries/${mediaLibraryUUID}?rel=snippet`}
                                                >
                                                    {t(
                                                        'MediaSnippetMediaLibrary.title'
                                                    )}
                                                </Link>
                                            </li>
                                            <li className="active">
                                                <i className="fas fa-clipboard-list" />{' '}
                                                {t('MediaLibraryRules.title')}
                                            </li>{' '}
                                        </React.Fragment>
                                    ) : null}

                                    {rel === 'page' ? (
                                        <React.Fragment>
                                            <li>
                                                <i className="fa fa-tachometer-alt" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}`}
                                                >
                                                    {t('Dashboard.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-file" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/pages`}
                                                >
                                                    {t(
                                                        'SideNavigation.globalpages'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-puzzle-piece" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/pages/${pageUUID}?rel=page`}
                                                >
                                                    {t('Page.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-images" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/pages/${pageUUID}/mediasnippets/${snippetUUID}?rel=page`}
                                                >
                                                    {t('MediaLibrarySnippet.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fas fa-images" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/pages/${pageUUID}/mediasnippets/${snippetUUID}/medialibraries/${mediaLibraryUUID}?rel=page`}
                                                >
                                                    {t(
                                                        'MediaSnippetMediaLibrary.title'
                                                    )}
                                                </Link>
                                            </li>
                                            <li className="active">
                                                <i className="fas fa-clipboard-list" />{' '}
                                                {t('MediaLibraryRules.title')}
                                            </li>{' '}
                                        </React.Fragment>
                                    ) : null}
                                </ol>

                                {ruleGroupPanels}

                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(MediaLibraryRules);
